import styled from 'styled-components'

import { mq, sizes } from '../../theme'

export const CardCarousel = styled.section`
  position: relative;
`

export const Container = styled.div`
  display: flex;
  position: relative;
  overflow-x: hidden;
`

export const List = styled.ul<{ currentSlideIdx: number }>`
  display: flex;
  position: relative;
  flex-direction: row;
  list-style: none;
  width: 100%;
  transition: transform 0.4s ease-in-out;
  transform: ${({ currentSlideIdx }) =>
    `translateX(${currentSlideIdx * -100}%)`};
`

export const CarouselItem = styled.li<{ index: number }>`
  display: flex;
  flex-shrink: 0;
  width: 100%;

  & > a,
  & > span {
    height: 30rem;
  }
`

export const Dots = styled.div`
  display: flex;
  justify-content: center;
  position: absolute;
  left: 2.5rem;
  width: calc(100% - 5rem);
  bottom: 1.5rem;

  @media ${mq(sizes.desktop)} {
    width: calc(50% - 5rem);
    left: 4rem;
    justify-content: flex-start;
  }
`

export const Dot = styled.button<{ active: boolean }>`
  background: ${({ theme, active }) =>
    active ? theme.colors.pureBlack : theme.colors.pureWhite};
  height: 1rem;
  width: 100%;
  margin: 0 0.25rem;
  border-radius: 50%;
  max-width: 1rem;
  box-shadow: 0 2px 5px rgb(0 0 0 / 15%);

  @media ${mq(sizes.desktop)} {
    height: 0.8rem;
    border-radius: 0.5rem;
    max-width: 6.5rem;
    margin: 0 0.5rem;
  }

  &:hover {
    cursor: pointer;
  }

  &:first-child {
    margin-left: 0;
  }

  &:last-child {
    margin-right: 0;
  }
`
